/* sticky-header.js — reveal-on-scroll-up header + overlay light→solid swap.
   This is the site's sticky header (the theme's native sticky isn't running
   on this theme). It reuses the theme's existing .site-header--stuck /
   .site-header--opening CSS, and on overlay pages (e.g. the homepage) it
   removes the wrapper's `is-light` class once pinned so the header switches
   from its transparent white-logo overlay state to the solid black-logo
   state — exactly what the native sticky used to do. Skips article/stores
   (header.liquid sets data-sticky="false" there).

   FIX (2026-07): the light→solid swap used to be gated on `isOverlay`
   (data-overlay read once at load). On the homepage that gate evaluated
   false at runtime, so the white sticky bar appeared but `is-light` was
   never removed — leaving the logo + currency white/invisible on the white
   bar. The is-light handling is now driven by `startsLight` (whether the
   wrapper loaded in the light overlay state) instead of the cached overlay
   flag, so it works reliably on the homepage. Non-overlay pages start
   without is-light, so `startsLight` is false there and nothing changes. */
(function () {
  var header = document.getElementById('SiteHeader');
  if (!header || header.getAttribute('data-sticky') !== 'true') return;

  var isOverlay = header.getAttribute('data-overlay') === 'true'; // used only for the spacer below
  var wrapper   = document.querySelector('.header-sticky-wrapper');
  var lightWrap = document.getElementById('HeaderWrapper');       // holds the .is-light class
  var body      = document.body;

  var headerH  = header.offsetHeight;
  var lastY    = window.pageYOffset;
  var ticking  = false;
  // Does this page load in the light/overlay state? (homepage + collection-with-image do.)
  // This — not the cached overlay flag — decides whether we manage is-light.
  var startsLight = !!(lightWrap && lightWrap.classList.contains('is-light'));

  body.classList.add('sticky-header');
  if (wrapper && !isOverlay) wrapper.style.height = headerH + 'px';

  function update() {
    var y = window.pageYOffset;

    if (y <= headerH) {
      // At the very top — normal header, and restore the light overlay if the page started light.
      header.classList.remove('site-header--stuck', 'site-header--opening');
      if (startsLight && lightWrap) lightWrap.classList.add('is-light');
    } else {
      // Pinned — reveal on scroll up, and switch the overlay header to solid (black logo + currency).
      header.classList.add('site-header--stuck');
      header.classList.toggle('site-header--opening', y < lastY); // up = reveal
      if (startsLight && lightWrap) lightWrap.classList.remove('is-light');
    }

    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  window.addEventListener('resize', function () {
    headerH = header.offsetHeight;
    if (wrapper && !isOverlay) wrapper.style.height = headerH + 'px';
  });
})();